import React from 'react';
import styled from 'styled-components';
interface LogoIconProps {
  gradientId?: string;
}

export const LogoContainer = styled.div`
  height: 40px;
  padding-top: 5px;
  padding-left: 4px;
  display: flex;
  margin-bottom: -0.5rem;
  flex-shrink: 0;
`;

const LogoIcon = ({ gradientId = 'paint0_linear_209_4965' }: LogoIconProps) => {
  return (
    <LogoContainer>
      <svg id={gradientId} width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.693 9.21497C23.2858 6.35137 22.1421 4.66753 20.0367 3.85929C18.6699 3.28571 17.0454 3.11841 13.3501 3.11841C11.1342 3.11841 9.32338 3.22052 8.40064 3.35523C6.33205 3.72459 4.89162 4.60235 4.07935 5.94942C3.04398 7.66802 2.85986 8.94773 2.85986 13.6972C2.85986 18.4467 2.89669 19.255 3.15661 20.7367C3.56167 23.0941 4.67069 24.5781 6.55516 25.3189C7.73132 25.7774 8.7602 25.9664 10.766 26.0316V23.8306C9.28005 23.772 8.58475 23.646 7.92194 23.4005C6.77609 22.9963 6.11111 22.0534 5.85335 20.5043C5.70606 19.6511 5.63242 17.6747 5.63242 14.575C5.63242 11.8809 5.64469 10.3766 5.66924 10.0623C5.81653 8.17643 6.1501 7.16613 6.88873 6.39048C7.73782 5.51488 8.99414 5.31282 13.4649 5.31282C16.7161 5.31282 17.7862 5.41277 18.7847 5.7843C19.9306 6.18842 20.5955 7.13136 20.8533 8.68049C21.0006 9.53363 21.0742 11.4985 21.0742 14.575V18.1795L21.0374 18.8204C21.0374 19.2919 20.888 20.4912 20.7233 21.3364L20.3399 22.1034C19.6901 23.407 18.4576 23.8263 14.6779 23.8676V24.0914H12.1912V23.8654C12.1912 23.8654 12.1761 23.8654 12.1696 23.8654V26.0598C12.4403 26.0598 12.7219 26.062 13.023 26.062C17.3075 26.062 18.4165 25.9621 20.041 25.3211C21.15 24.917 22.1919 23.9501 22.5168 23.5026L23.4027 21.5819C23.7731 20.1327 23.8468 18.9877 23.8468 13.5647C23.8468 10.7684 23.81 10.2296 23.6995 9.21932L23.693 9.21497Z"
          fill="#1784EC"
        />
        <path
          d="M13.3609 15.379C14.5979 15.379 15.6006 14.3732 15.6006 13.1324C15.6006 11.8917 14.5979 10.8859 13.3609 10.8859C12.124 10.8859 11.1212 11.8917 11.1212 13.1324C11.1212 14.3732 12.124 15.379 13.3609 15.379Z"
          fill="#FF6C0A"
        />
        <path
          d="M12.1869 16.9563L12.1544 26.0316C12.6093 26.036 13.3609 24.3022 13.8678 24.5629C14.2512 24.7584 14.3746 24.6042 14.6757 24.5998V16.9563H12.1869Z"
          fill="#1784EC"
        />
      </svg>
    </LogoContainer>
  );
};

export default LogoIcon;
